import { Base } from "../../framework/base";

export interface IRecordQualificationUserFurtherEducation {
    id: string;
    code: string;
    valid: boolean;
    validityEndDate: number;
}

export class RecordQualificationUserFurtherEducation implements IRecordQualificationUserFurtherEducation {
    id: string;
    code: string;
    valid: boolean;
    validityEndDate: number;

    constructor();
    constructor(obj: IRecordQualificationUserFurtherEducation);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.valid = obj && obj.valid || false;
        this.validityEndDate = obj && obj.validityEndDate || null;
    }

    public static Create(id: string, code: string, valid: boolean, validityEndDate: number): IRecordQualificationUserFurtherEducation {
        const result = new RecordQualificationUserFurtherEducation();
        result.id = id;
        result.code = code;
        result.valid = valid;
        result.validityEndDate = validityEndDate;
        return result;
    }

    static sortRecordQualificationUserFurtherEducation(items: IRecordQualificationUserFurtherEducation[], column: string, asc: boolean): IRecordQualificationUserFurtherEducation[] {
        if (!items && items.length < 2) return items;
        if (column === "validity") {
            return items.sort((a: IRecordQualificationUserFurtherEducation, b: IRecordQualificationUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare((a.id ? 10 : 0) + (a.valid ? 1 : 0), (b.id ? 10 : 0) + (b.valid ? 1 : 0))); });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordQualificationUserFurtherEducation, b: IRecordQualificationUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else {
            return items.sort((a: IRecordQualificationUserFurtherEducation, b: IRecordQualificationUserFurtherEducation) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}
